<script>
	export let label = 'Value';
	export let value = 128;
	export let min = 0;
	export let max = 255;
	export let step = 1;
	export let color = 'white';
</script>

<style>
	div {
		margin:0.05em 0;
		width:calc(100% - 1em);
	}
	span {
		text-align: right;
		margin-right:0.6rem;
	}
	em {
		font-style:normal;
		color:var(--custom);
		font-weight:400;
		display:inline-block;
	}
	input {
		height:1.1em;
		outline:none;
		margin:0.15em 0;
		pointer-events:auto;
	}
	input[type='range'],
	input[type='range']::-webkit-slider-runnable-track,
	input[type='range']::-webkit-slider-thumb {
	  -webkit-appearance: none;
		background:transparent;
	}
	input[type='range']::-webkit-slider-runnable-track {
	  height: 0.15em;
		background: var(--custom);
	}
	input[type='range']::-webkit-slider-thumb {
	  width: 1em;
	  height: 1em;
	  cursor: pointer;
	  background: var(--black);
		border:0.15em solid var(--custom);
	  border-radius: 50%;
	  margin-top: -0.45em;
	}
</style>

<div class="flex" style="--custom:var(--{color})">
	<span class="text-right text-ui w-40">{label} <em>{Math.abs(value) < 0.0001 && value != 0 ? '~0' : Math.round(value*100)/100}</em></span>
	<input class="w-60" type="range" {min} {max} {step} bind:value={value}>
</div>
